<template>
    <v-app>
        <NavBar/>
        <v-content>
            <router-view/>
        </v-content>

        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <b>gofiqr by new'ish</b> / Hostrupsvej 2, 1. tv. / 1950 Frederiksberg C / Tlf. 2222 3701 /
                    <a href="mailto:info@gofiqr.com">
                        <v-icon >mdi-email</v-icon>
                    </a>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-img :src="require('@/assets/newish-byen.png')" contain/>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    import NavBar from "@/components/NavBar";

    export default {
        name: 'App',
        components: {NavBar},
        methods: {
        },
    };
</script>


<style>
    #app {
        font-family: 'Source Sans Pro', 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
        background-color: #ffffff;
    }
    h1 {
        font-weight: 400;
        font-size: 3em;
        color: #1d6c91;

    }
    h2 {
        font-weight: 400;
        font-size: 1.7em;
        color: #3e72a3;
    }
    h3 {
        font-weight: 300;
        font-size: 1.3em;
    }
    h4 {
        font-weight: 300;
        font-size: 1.2em;
    }
    blockquote {
        margin: 1em 0;
        padding: 0 0 0 1em;
        border: 1px solid #263333;
        border-width: 0 0 0 1px;
        font-style: italic;
    }
</style>
